import { GameConfigDTO, GameFamilyType } from '@envclient/envcore';
import { MeepleType } from './Meeple';
import { Type } from '@dipscope/type-manager';
import { CcsonGameTypeDTO, gameConfigs } from '../ccson/ccsonGameConfigLoader';
/**
 * Type declarations and helpers for parsing tile game config jsons.
 *
 */
// duplicate in ccsonenv
export interface NodeDef {
  id: number;
  type: string;
  x: number;
  y: number;
  conns: number[];
  cities?: number[];
}

export type KGameTypeDTO = 'koenigsburg_mini' | 'koenigsburg';

@Type({
  injectable: true
})
export class NodeDefClass implements NodeDef {
  id: number;
  type: string;
  x: number;
  y: number;
  conns: number[] = [];
  cities?: number[] = [];
}

@Type({
  injectable: true
})
export class TileDefClass implements TileDef {
  type: number;
  count?: number;
  sides: string;
  nodes: Array<NodeDef>;
  rot?: number;
}

export interface TileDef {
  type: number;
  count?: number;
  sides: string;
  nodes: Array<NodeDef>;
  rot?: number;
}
@Type({
  injectable: true
})
export class TileGameConfig implements GameConfigDTO {
  segments: string;
  random: boolean;
  credits: number;
  points: number;
  minVersion: number;
  family: GameFamilyType;
  label: string;

  type: CcsonGameTypeDTO | KGameTypeDTO;
  tiles: number;
  meeples: number;
  meepleCount: { [P in MeepleType]?: number };
  startTile: number;
  thumbnailTile: number;

  //default mini config for TM

  constructor() {
    return structuredClone(gameConfigs[1]);
  }
}

@Type({ injectable: true })
export class TileCount extends Map<number, number> {}
@Type({ injectable: true })
export class TileCountMap extends Map<string, TileCount> {}

export function parseTileCount(tileCountJson: Record<string, string[]>): TileCountMap {
  const tileCount = new Map();
  Object.entries(tileCountJson).forEach(([key, value]) => {
    const tc: TileCount = new Map();
    value.forEach((s) => {
      const parts = s.split(':');
      tc.set(parseInt(parts[0]), parseInt(parts[1]));
    });
    tileCount.set(key, tc);
  });
  return tileCount;
}
